import React from "react";
import Modal from "./Modal";
import Button from "./Button";

const ConfirmModal = ({
  open,
  title = "Confirm delete",
  message = "Are you sure you want to delete this record? This action cannot be undone.",
  confirmLabel = "Delete",
  confirmIcon = "delete",
  cancelLabel = "Cancel",
  loading = false,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal
      open={open}
      title={title}
      onClose={loading ? undefined : onCancel}
      size="sm"
      closeOnBackdrop={!loading}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant="danger" icon={confirmIcon} onClick={onConfirm} disabled={loading}>
            {loading ? "Please wait..." : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm text-gray-700 leading-relaxed">{message}</p>
    </Modal>
  );
};

export default ConfirmModal;
